/* 典韋（陳留己吾人） */
import { defineHero, U, S } from '../define.ts';

export default defineHero({
  id: 'dianwei', name: '典韋', sub: '陳留己吾人', faction: 'wei', role: '戰士/坦克', weapon: 'twin',
  look: {
    weaponName: '雙鐵戟', bulk: 1.2, size: 1.08, skin: '#a8714a', hair: '#221b17', beard: 'bushy', eye: 'fierce', head: 'headband', fx: '#f0c47a',
    c: { armor: '#4b5872', sleeve: '#34405a', cloth: '#2e3a58', trim: '#a88a4a', pants: '#262c3c', boot: '#23201e', belt: '#5a3a22', metal: '#8f97a0', band: '#b53a2c', pole: '#4a3b30', plume: '#b53a2c' },
  },
  skills: [
    ['動地跺', 'roar', '猛擊地面，對周圍敵人造成 {75/100/125/150} 傷害並震暈 {1.5/2/2.5/3} 秒。', { x: { k: 'aoe', self: true, dmg: [75, 100, 125, 150], r: [200, 240, 280, 280], cc: { stun: [1.5, 2, 2.5, 3] }, ground: true, fx: 'slam' }, aim: S([200, 240, 280, 280]), cd: 15, mp: 100, el: 'earth' }],
    ['暈擊', 'passive', '普攻有 {10/15/20/25}% 機率附加 35 傷害並震暈 1 秒。', { pv: { bonus: { chance: [10, 15, 20, 25], dmg: 35, stun: 1 } } }],
    ['野性戰魂', 'passive', '每秒多回復 {0.6/0.9/1.2/1.5} 生命，移速 +{3/6/9/12}%。', { pv: { regen: [0.6, 0.9, 1.2, 1.5], msP: [3, 6, 9, 12] } }],
    ['妖火', 'bolt', '妖火纏身 20 秒：目標防禦 -{5/10/15}，且無法隱身躲藏。', { x: { k: 'nuke', debuff: { armor: [5, 10, 15], dur: 20 }, reveal: 20, fx: 'fire' }, aim: U(480) }],
  ],
});
